<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Cobranza </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div>
            <div class="content_accion" v-if="!isLoading">
                <v-expansion-panels v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-title>Filtros</v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <div class="override_content_flex mt-4">
                                <div class="col-flex-3">
                                    <v-text-field type="date" variant="outlined" label="Fecha Inicio"
                                        v-model="formGroup.data.fecha_inicial"
                                        :rules="formGroup.rules.fecha_inicial"></v-text-field>
                                </div>
                                <div class="col-flex-3">
                                    <v-text-field type="date" variant="outlined" label="Fecha Fin"
                                        :min="formGroup.data.fecha_inicial" :max="validateMaxDate()"
                                        v-model="formGroup.data.fecha_final"
                                        :rules="formGroup.rules.fecha_final"></v-text-field>
                                </div>
                                <div class="col-flex-3" v-if="tipoUsuario === 'Multiadmin'">
                                    <v-select v-model="formGroup.data.despacho" label="Despachos" :items="arrDespachos"
                                        variant="outlined" item-title="nombre" item-value="id_db"
                                        @update:model-value="getGrupos" prepend-inner-icon="mdi-magnify"></v-select>
                                </div>
                                <div class="col-flex-3"
                                    v-if="tipoUsuario === 'Administrador' || tipoUsuario === 'Supervisor' || tipoUsuario === 'Multiadmin'">
                                    <!-- :rules="formGroup.rules.id_grupo" -->
                                    <v-autocomplete v-model="formGroup.data.id_grupo" label="Grupos" variant="outlined"
                                        :items="arrGroupList" item-title="nombre" item-value="id_grupo"
                                        prepend-inner-icon="mdi-magnify"
                                        @update:model-value="getUsersByGroups()"></v-autocomplete>
                                </div>
                                <div class="col-flex-3"
                                    v-if="tipoUsuario === 'Administrador' || tipoUsuario === 'Supervisor' || tipoUsuario === 'Multiadmin'">
                                    <v-select v-model="formGroup.data.usuarios" :rules="formGroup.rules.usuarios"
                                        label="Usuarios" variant="outlined" :items="arrUsersByGroups"
                                        :disabled="arrUsersByGroups.length === 0" item-title="fullName" item-value="id"
                                        prepend-inner-icon="mdi-magnify" multiple>
                                        <template v-slot:prepend-item>
                                            <v-list-item title="Seleccionar todos" @click="toggleSelectAll">
                                                <template v-slot:prepend>
                                                    <v-checkbox-btn
                                                        :color="someSelected ? 'indigo-darken-4' : undefined"
                                                        :indeterminate="someSelected && !allSelected"
                                                        :model-value="allSelected" />
                                                </template>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-select>
                                    <div v-if="formGroup.data.id_grupo && (!formGroup.data.usuarios || formGroup.data.usuarios.length === 0)"
                                        class="text-caption text-red">
                                        Selecciona los usuarios del grupo.
                                    </div>
                                </div>
                                <div class="col-flex-12 actions_buttons">
                                    <v-btn color="indigo-darken-3" style="margin-top: 5px;" prepend-icon="mdi-plus"
                                        text="Buscar" :disabled="validateFilter()" @click="applyFilterBar()"></v-btn>
                                </div>
                            </div>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <div v-if="!isLoading && !isLoadingFilter" style="width: 100%; height: calc(100% - 127px); overflow: auto;">
                <!-- style="width: calc(95%)" -->
                <apexchart height="95%" type="bar" :options="chartOptions" :series="series"></apexchart>

            </div>


            <div v-if="isLoading" class="content_load h-100">
                <v-progress-circular :size="100" :width="7" color="indigo-darken-3" indeterminate></v-progress-circular>
                <i>Espere un Momento</i>
                <div>Cargando Información</div>
            </div>
            <div v-if="isLoadingFilter" class="content_load h-100">
                <v-progress-circular :size="100" :width="7" color="indigo-darken-3" indeterminate></v-progress-circular>
                <i>Espere un Momento</i>
                <div>Cargando Información de la Gráfica</div>
            </div>
        </v-card>
        <SnackbarComponent :value="snackbarData" />
    </div>
</template>

<script>
import { EstadisticaService } from '@/services/EstadisticaService'
import { EncryptService } from '@/services/EncryptService'
// import { SocketService } from '@/services/SocketService'
import VueApexCharts from "vue3-apexcharts";
import SnackbarComponent from '@/components/Snackbar.vue'
export default {
    name: 'GraficasComponent',
    components: {
        SnackbarComponent,
        apexchart: VueApexCharts,
    },
    data() {
        return {
            isLoading: false,
            isLoadingUsers: false,
            isLoadingFilter: false,
            chartOptions: {
                chart: {
                    id: "vuechart-example",
                    toolbar: {
                        show: true, // Enables the toolbar
                        tools: {
                            download: true, // Enables the download button
                        }
                    },
                },
                title: {
                    text: 'Total: ',
                    align: 'center',
                    style: {
                        fontSize: '15px',
                        fontWeight: 'bold',
                        color: '#263238'
                    }
                },
                xaxis: {
                    labels: {
                        formatter: function (value) {
                            if (!value) return "";

                            let value2 = String(value).split(' ');

                            return value2;
                        },
                        style: {
                            fontSize: '10px',   // 👈 tamaño de letra
                            colors: ['#263238'], // puedes pasar array o un solo color
                            whiteSpace: 'pre-line'
                        }
                    },
                    categories: [],
                },
            },
            series: [],
            totalGen: 0,
            formGroup: {
                data: {
                    fecha_inicial: null,
                    fecha_final: null,
                    codigo_accion: null,
                    id_grupo: null,
                    usuarios: null,
                    despacho: null
                },
                rules: {
                    fecha_inicial: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                    fecha_final: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                    codigo_accion: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                    id_grupo: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                    usuarios: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo es obligatorio`
                            }
                            return true
                        }
                    ],
                }
            },
            arrActionCode: [],
            tipoUsuario: null,
            arrGroupList: [],
            arrUsersByGroups: [],
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            panel: [],
            arrDespachos: [],
        }
    },
    async created() {

        this.tipoUsuario = await EncryptService.decrypt(localStorage.getItem('TIPO'));

        this.isLoading = true
        await this.getActionCodeList()
        await this.getGrupos()
        await this.getDespachos();
        this.isLoading = false

        // SocketService.test()

    },
    computed: {
        allSelected() {
            const usuarios = this.formGroup?.data?.usuarios || [];
            const users = this.arrUsersByGroups || [];
            return usuarios.length === users.length && users.length > 0;
        },
        someSelected() {
            const usuarios = this.formGroup?.data?.usuarios || [];
            return usuarios.length > 0 && !this.allSelected;
        }
    },
    methods: {
        updateChart() {
            const max = 90;
            const min = 20;
            const newData = this.series[0].data.map(() => {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            });

            const colors = ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"];

            this.chartOptions = {
                colors: [colors[Math.floor(Math.random() * colors.length)]],
            };
            // In the same way, update the series option
            this.series = [
                {
                    data: newData,
                },
            ];
        },
        getActionCodeList: async function () {
            await EstadisticaService.getActionCode().then((resp) => {
                if (!resp.error) {
                    this.arrActionCode = resp.response
                    this.arrActionCode.forEach(element => {
                        element.nombre = element.codigo + ' - ' + element.descripcion
                    })
                } else {
                    this.dialogData = {
                        openDialog: true,
                        title: 'Ocurrió un Problema',
                        description: resp.msg,
                    }
                }
            })
        },
        getGrupos: async function () {
            if (this.tipoUsuario == 'Administrador') {
                await EstadisticaService.getGruposAdmin(localStorage.getItem('TIPO'), null).then((resp) => {
                    if (!resp.error) {
                        this.arrGroupList = [{ id_grupo: null, nombre: 'Ninguno' }]
                        this.arrGroupList = this.arrGroupList.concat(resp.response)
                    } else {
                        this.dialogData = {
                            openDialog: true,
                            title: 'Ocurrió un Problema',
                            description: resp.msg,
                        }
                    }
                })
            } else if (this.tipoUsuario == 'Multiadmin') {
                this.formGroup.data.id_grupo = null;
                this.formGroup.data.usuarios = null;
                await EstadisticaService.getGruposAdmin(localStorage.getItem('TIPO'),
                    this.formGroup.data.despacho).then((resp) => {
                        if (!resp.error) {
                            this.arrGroupList = [{ id_grupo: null, nombre: 'Ninguno' }]
                            this.arrGroupList = this.arrGroupList.concat(resp.response)
                        } else {
                            this.dialogData = {
                                openDialog: true,
                                title: 'Ocurrió un Problema',
                                description: resp.msg,
                            }
                        }
                    })
            } else {
                const ID = localStorage.getItem('ID')
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                await EstadisticaService.getGruposSupervisor(ENC_ID).then((resp) => {
                    if (!resp.error) {
                        this.arrGroupList = resp.response
                    } else {
                        this.dialogData = {
                            openDialog: true,
                            title: 'Ocurrió un Problema',
                            description: resp.msg,
                        }
                    }
                })
            }
        },
        getUsersByGroups: async function () {
            this.isLoadingUsers = true
            const ID_GROUP = this.formGroup.data.id_grupo
            if (ID_GROUP === null) {
                this.formGroup.data.usuarios = null
                this.arrUsersByGroups = []
                return;
            }
            const ENC_GROUP = await EncryptService.encrypt(`${ID_GROUP}`)
            await EstadisticaService.getUsersByGroups(ENC_GROUP).then(
                (responseData) => {
                    if (!responseData.error) {
                        for (let element of responseData.response) {
                            element.fullName = `${element.name} ${element.last_name} (${element.username})`
                        }
                        this.arrUsersByGroups = responseData.response
                    } else {
                        this.dialogData = {
                            openDialog: true,
                            title: 'Ocurrió un Problema',
                            description: responseData.msg,
                        }
                    }
                }
            )
            this.isLoadingUsers = false
        },
        validateFilter: function () {
            const FECHA_INICIAL = this.formGroup.data.fecha_inicial
            if (FECHA_INICIAL === null || FECHA_INICIAL === undefined || FECHA_INICIAL === '') {
                return true
            }
            const FECHA_FINAL = this.formGroup.data.fecha_final
            if (FECHA_FINAL === null || FECHA_FINAL === undefined || FECHA_FINAL === '') {
                return true
            }

            if (this.tipoUsuario == 'Multiadmin') {
                const DESPACHOS = this.formGroup.data.despacho;
                if (DESPACHOS == null || DESPACHOS == undefined || DESPACHOS == '') {
                    return true;
                }
            }

            return false
        },
        applyFilterBar: async function () {
            this.isLoadingFilter = true

            this.series = [];
            this.chartOptions.xaxis.categories = [];

            const FECHA_INICIAL = this.formGroup.data.fecha_inicial
            const FECHA_FINAL = this.formGroup.data.fecha_final

            let USUARIOS = [];

            if (this.tipoUsuario === 'Administrador' || this.tipoUsuario === 'Supervisor' || this.tipoUsuario === 'Multiadmin') {
                USUARIOS = this.formGroup.data.usuarios
                if (USUARIOS === null || USUARIOS === undefined || USUARIOS.length === 0) {
                    USUARIOS = []
                } else {
                    let arrTemp = [];
                    for (let element of USUARIOS) {
                        element = await EncryptService.encrypt(`${element}`)
                        arrTemp.push(element)
                    }
                    USUARIOS = arrTemp;
                }
            } else {
                const ID = localStorage.getItem('ID')
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                USUARIOS = [ENC_ID]
            }

            let arrDateInit = FECHA_INICIAL.split('-')
            let dateInitial = new Date(parseInt(arrDateInit[0]), parseInt(arrDateInit[1]) - 1, arrDateInit[2])

            let arrDateFinal = FECHA_FINAL.split('-')
            let dateFinal = new Date(parseInt(arrDateFinal[0]), parseInt(arrDateFinal[1]) - 1, arrDateFinal[2])

            let arrDates = this.getBetweenDates(dateInitial, dateFinal);
            let arrStrDate = [];
            for (const DATE of arrDates) {
                let year = DATE.getFullYear();
                let month = (DATE.getMonth() + 1 < 10) ? `0${DATE.getMonth() + 1}` : DATE.getMonth() + 1
                let date = (DATE.getDate() < 10) ? `0${DATE.getDate()}` : DATE.getDate()
                let strDate = `${year}-${month}-${date}`
                arrStrDate.push(strDate)
            }
            this.chartOptions.xaxis.categories = arrStrDate;

            let despacho = '';
            if (this.tipoUsuario === "Multiadmin") {
                despacho = this.formGroup.data.despacho;
            } else {
                despacho = localStorage.getItem('DESPACHO');
            }

            const REQUEST_FILTER = {
                fecha_inicial: FECHA_INICIAL,
                fecha_final: FECHA_FINAL,
                id_user_list: USUARIOS,
                despacho: despacho
            }

            await EstadisticaService.getPaymentsStatistics(REQUEST_FILTER).then(
                (responseData) => {
                    if (!responseData.error && responseData.msg !== 'No hay estadisticas disponibles para este usuario/s') {
                        if (responseData.response.length === 0) {
                            this.snackbarData.description = `No hay estadisticas disponibles para este usuario/s`
                            this.snackbarData.openSnackbar = true
                            this.panel = []
                            return;
                        }
                        if (USUARIOS.length === 0) {
                            let arrTemp = [];
                            let arrDataTemp = [];
                            let arrCategoryTemp = []
                            for (let data of responseData.response) {
                                let onlyDate = data.day_filter.split(' ')[0]
                                arrCategoryTemp.push(onlyDate)
                                arrTemp.push(data.sum)
                            }
                            arrDataTemp.push({
                                data: arrTemp
                            });
                            this.series = arrDataTemp;
                            this.totalGen = this.series.reduce((acc, serie) => {
                                return acc + serie.data.reduce((suma, val) => suma + val, 0)
                            }, 0);

                            this.chartOptions.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(this.totalGen);

                            this.chartOptions.xaxis.categories = arrCategoryTemp;
                            this.panel = []
                        } else if (USUARIOS.length === 1) {
                            let arrTemp = [];
                            let arrDataTemp = [];
                            for (let rangeDates of arrDates) {
                                let value = 0
                                for (let data of responseData.response.info) {
                                    let arrDatetime = data.day_filter.split(' ')
                                    let arrDateInit = arrDatetime[0].split('-')
                                    let dateValue = new Date(parseInt(arrDateInit[0]), parseInt(arrDateInit[1]) - 1, arrDateInit[2])
                                    if (this.sonFechasIguales(rangeDates, dateValue)) {
                                        value = data.sum
                                    }
                                }
                                arrDataTemp.push(value)
                            }
                            arrTemp.push({
                                name: `${responseData.response.name}`,
                                data: arrDataTemp
                            });
                            this.series = arrTemp;
                            this.totalGen = this.series.reduce((acc, serie) => {
                                return acc + serie.data.reduce((suma, val) => suma + val, 0)
                            }, 0);

                            this.chartOptions.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(this.totalGen);
                            this.chartOptions.xaxis.categories = arrStrDate;
                            this.panel = []
                        } else if (USUARIOS.length > 1) {
                            let arrCategoryTemp = []
                            let arrTemp = [];
                            let arrDataTemp = [];
                            for (let data of responseData.response) {
                                arrCategoryTemp.push(data.name)
                                arrTemp.push(data.cobranza)
                            }
                            arrDataTemp.push({
                                data: arrTemp
                            });
                            this.series = arrDataTemp;
                            this.totalGen = this.series.reduce((acc, serie) => {
                                return acc + serie.data.reduce((suma, val) => suma + val, 0)
                            }, 0);

                            this.chartOptions.title.text = "Total: $" + new Intl.NumberFormat('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(this.totalGen);
                            this.chartOptions.xaxis.categories = arrCategoryTemp;
                            this.panel = []
                        }
                    } else {
                        this.chartOptions.title.text = "Total: $0"
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingFilter = false
            this.panel = false;
        },
        validateMaxDate: function () {
            let FECHA_INICIAL = this.formGroup.data.fecha_inicial
            if (FECHA_INICIAL === null) {
                return;
            }
            let arrDateInit = FECHA_INICIAL.split('-')
            let dateInitial = new Date(parseInt(arrDateInit[0]), parseInt(arrDateInit[1]) - 1, arrDateInit[2])

            dateInitial.setDate(dateInitial.getDate() + 32);

            let year = dateInitial.getFullYear();
            let month = (dateInitial.getMonth() + 1 < 10) ? `0${dateInitial.getMonth() + 1}` : dateInitial.getMonth() + 1
            let date = (dateInitial.getDate() < 10) ? `0${dateInitial.getDate()}` : dateInitial.getDate()
            let strMaxDate = `${year}-${month}-${date}`
            return strMaxDate;
        },
        getBetweenDates: function (initialDate, finalDate) {
            let arrDatesBetween = [];
            while (initialDate < finalDate) {
                arrDatesBetween.push(new Date(initialDate));
                initialDate.setDate(initialDate.getDate() + 1);
            }
            arrDatesBetween.push(finalDate);
            return arrDatesBetween;
        },
        sonFechasIguales: function (fecha1, fecha2) {
            const year1 = fecha1.getFullYear();
            const month1 = fecha1.getMonth();
            const day1 = fecha1.getDate();

            const year2 = fecha2.getFullYear();
            const month2 = fecha2.getMonth();
            const day2 = fecha2.getDate();

            return year1 === year2 && month1 === month2 && day1 === day2;
        },
        getDespachos: async function () {
            let idUser = await EncryptService.encrypt(localStorage.getItem('ID'));
            await EstadisticaService.getDespachosByUser(idUser).then(async (response) => {
                if (!response.error) {
                    let tempArrDespachos = [];
                    for (const element of response.response) {
                        tempArrDespachos.push({
                            id_db: await EncryptService.encrypt(element.nombre_bd),
                            id_normal: element.id_despacho,
                            nombre: `${element.nombre_bd}`
                        })
                    }
                    this.arrDespachos = tempArrDespachos;
                }
            })
        },
        toggleSelectAll() {
            const usuarios = this.formGroup?.data?.usuarios || [];
            const users = this.arrUsersByGroups || [];
            if (usuarios.length === users.length && users.length > 0) {
                this.formGroup.data.usuarios = [];
            } else {
                this.formGroup.data.usuarios = users.map(user => user.id);
            }
        }
    },
};

</script>

<style>
.content_accion {
    padding-bottom: 10px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}

.dates {
    float: left;
    margin: 1vh;
}

.content_table {
    overflow: auto;
    height: 52vh;

}

.content_main {
    padding-top: 20px;
}

.card {
    max-width: 180vh;
    max-height: 75vh;
    margin: 8vh;
}

.btn-searhc {
    float: left;
    margin-top: 3vh;
    margin-right: 3vh;
}

.text-body-2 {
    font-size: 14px !important;
    font-weight: 400;
    text-transform: none !important;
}

.text-caption {
    margin-top: -10px;
}
</style>